import type { ApiOrgType } from '#/modules/listing/orgs/api/types/ApiOrgType';

type Props = {
  orgType: ApiOrgType;
};

export function getOrgDetailFields({ orgType }: Props) {
  let fields: { fields: string[] }[] = [];

  // TODO: Fix this from eslint v9 update
  // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
  if (orgType === 'CONSULTANT') {
    fields = [
      {
        fields: ['services'],
      },
      {
        fields: ['clients'],
      },
    ];
  }

  // TODO: Fix this from eslint v9 update
  // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
  if (orgType === 'RECRUITER') {
    fields = [
      {
        fields: ['clients'],
      },
    ];
  }

  // TODO: Fix this from eslint v9 update
  // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
  if (orgType === 'CORPORATION') {
    fields = [
      {
        fields: ['isSocialEnterprise'],
      },
      {
        fields: ['isBCorp'],
      },
      {
        fields: ['isHospiceProvider'],
      },
      {
        fields: ['relatedJobAreas'],
      },
      {
        fields: ['relatedJobCount'],
      },
    ];
  }

  // TODO: Fix this from eslint v9 update
  // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
  if (orgType === 'CORPORATION') {
    fields.push({ fields: ['orgSize'] });
  }

  // TODO: Fix this from eslint v9 update
  // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
  if (orgType === 'COMMUNITY') {
    fields = [{ fields: ['howToGetInvolved'] }, { fields: ['timeActive'] }];
  }

  if (fields.length > 0) {
    fields = [
      {
        fields: ['orgTypeDetailsIntro'],
      },
    ].concat(fields);
  }
  return fields;
}
